import React, { useRef, useState } from "react";
import { changeShops } from "services/auth/actions";
import { useSelector, useDispatch } from "react-redux";
import { toastAlert } from "@paylixecommerce/shared/components";
import useClickOutside from "hooks/useClickOutside";
import { useHistory } from "react-router-dom";
import { Store, Plus, MigrateStore } from "./icons/icons/icons";
import { Settings } from "./icons/icons";
import getCDNLink from "../../../../../constants/cdn-link";
import MigrationModal from "./MigrationModal";

import "./shops-dropdown.scss";


export default ({ mobile }) => {

	let { shop, shops = [] } = useSelector(({ auth }) => auth);
	let { profile } = useSelector(({ auth }) => auth);

	let [dropdown, showDropdown] = useState(false);
	let [showMigrationModal, setShowMigrationModal] = useState(false);

	let ref = useRef();
	let dispatch = useDispatch();
	let history = useHistory();

	let switchShop = (id) => {
		dispatch(changeShops(id))
			.catch(err => toastAlert('error', (err && err.error) || 'Something went wrong!'))
	}

	useClickOutside(ref, () => {
		if (dropdown === true) {
			showDropdown(false);
		}
	});

	const handleMigrateClick = () => {
		setShowMigrationModal(true);
		showDropdown(false);
	};

	let image;
	if(shop && shop.cloudflare_image_id) {
		image = getCDNLink({ id: shop.cloudflare_image_id, type: "avatar" });
	}

	return <>
		<div className={`sidebar-shops ${dropdown ? "open" : ""} ${mobile ? "mt-0" : ""}`} onClick={() => showDropdown(!dropdown)}  ref={ref}>

			<div className="sidebar-shops-current">
				{shop && shop.cloudflare_image_id ?
					<img src={image} alt=""/> :
					<Store style={{ transform: "scale(.75)", color: "var(--black5)" }} />
				}

				<div className="sidebar-shops-current-data">
					<div className="sidebar-shops-name">{shop && shop.name}</div>
					<span>{profile && profile.email}</span>
				</div>
			</div>

			<div className="sidebar-shops-dropdown">
				<div className="sidebar-shops-dropdown-body">
					{shops.length ? shops.filter(({ id }) => shop.id !== id).map(({ name, id, cloudflare_image_id }) => {

						let image;
						if(cloudflare_image_id) {
							image = getCDNLink({ id: cloudflare_image_id, type: "avatar" });
						}

						return (
							<div key={id} onClick={() => switchShop(id)} className="sidebar-shops-dropdown-body-item">
								<div className="sidebar-shops-dropdown-body-item-img">
									{cloudflare_image_id ? <img src={image} alt=""/> : <Store />}
								</div>
								<span>
									{name}
								</span>
							</div>
						);

					}) : null}

					<div onClick={() => history.push('/settings/create/shop')} className="sidebar-shops-dropdown-body-item">
						<div className="sidebar-shops-dropdown-body-item-img">
							<Plus />
						</div>
						<span>
							Create Shop
						</span>
					</div>
				</div>

				<div className="sidebar-shops-dropdown-footer">
					<div onClick={handleMigrateClick} className="sidebar-shops-dropdown-footer-item">
						<MigrateStore />
						<span>
							Migrate Store
						</span>
					</div>
					
					<div onClick={() => history.push('/settings/shop/general')} className="sidebar-shops-dropdown-footer-item">
						<Settings />
						<span>
							Store Settings
						</span>
					</div>
				</div>
			</div>

		</div>

		<MigrationModal 
			open={showMigrationModal} 
			closeModal={() => setShowMigrationModal(false)} 
		/>
	</>
}